import React from "react";

export default function SuccessDisclaimer() {
  return (
    <>
      <small className="d-block disclaimer mt-4">
        If you need any help, please email{" "}
        <a href="mailto:help@blocktickets.xyz">help@blocktickets.xyz</a> and we
        will get back to you shortly!
      </small>
    </>
  );
}
